<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-filter" />
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  name: 'process-filter',
  props: {
    comId: {
      default: '',
    },
    comTp: {
      default: 'FLT',
    },
    isHistory: {
      default: false,
    },
    fltrTpCdList: {
      default: Array,
    },
    manage: {
      default: false,
    },
  },
  data: () => ({
    procIconSize: 24,
    showClose: false,
    formData: {
      byProcSetup: true,
      fltrId: '',
      fltrNm: '',
      fltrTpCd: '',
      srcPttn: '',
    },
    userData: {
      key: '',
      value: '',
    },
    checkDialogInfo: '',
    checkDialogColor: 'warning',
    hideItem: true,
    hideIcon: 'fa fa-caret-down',
    hideText: 'Expand',
    nodeId: '',
    numOfUse: 0,
    formEmit: {
      comTp: 'FLT',
      comId: '',
      nodeId: '',
    },
  }),
  watch: {
    comId() {
      return this.comId;
    },
  },
  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
  },

  mounted() {},
  methods: {
    resetForm() {
      this.formData = {
        byProcSetup: true,
        fltrId: '',
        fltrNm: '',
        fltrTpCd: '',
        srcPttn: '',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
        fltrTpCdList: this.fltrTpCdList,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.fltrId = id;
        if (!this.formData.fltrId) {
          this.resetForm();
          return;
        }
        this.selectFilter();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.formData.fltrId = this.comId;
        if (this.formData.fltrId !== '') {
          this.selectFilter();
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
            fltrTpCdList: this.fltrTpCdList,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    selectFilter() {
      const id = this.formData.fltrId;
      let index = this.filterList.findIndex((e) => e.fltrId == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.formData = Object.assign({}, this.filterList[index]);
        this.formEmit = {
          comId: this.formData.fltrId,
          nodeId: this.nodeId,
          comName: this.formData.fltrNm,
          comTp: this.comTp,
          fltrTpCdList: this.fltrTpCdList,
        };
        EventBus.$emit('set-comp-id', this.formEmit);
      } else {
        this.resetForm();
      }
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
  },
  computed: {
    filterList() {
      return this.$store.getters.filterSelectBoxList;
    },
  },
};
</script>
